/* app/js/src/components/common/remove-button/remove-button.component.scss */
.icon-button,
button.white-hover-white,
button.coral-hover-black,
button.hover-black,
button.button {
  display: block;
  width: 20px;
  height: 20px;
  background: none;
  border: none;
  padding: 0;
  position: relative;
}
.icon-button > svg,
button.white-hover-white > svg,
button.coral-hover-black > svg,
button.hover-black > svg,
button.button > svg {
  width: 20px;
  height: 20px;
  fill: #93a9bf;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.icon-button:focus,
button.white-hover-white:focus,
button.coral-hover-black:focus,
button.hover-black:focus,
button.button:focus {
  outline: none;
}
.icon-button:hover > svg,
button.white-hover-white:hover > svg,
button.coral-hover-black:hover > svg,
button.hover-black:hover > svg,
button.button:hover > svg {
  fill: #ffffff;
}
.icon-button:hover::after,
button.white-hover-white:hover::after,
button.coral-hover-black:hover::after,
button.hover-black:hover::after,
button.button:hover::after {
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  opacity: 1;
}
.icon-button::after,
button.white-hover-white::after,
button.coral-hover-black::after,
button.hover-black::after,
button.button::after {
  content: attr(data-title);
  color: #ffffff;
  font-size: 0.7em;
  margin-left: -10px;
  display: block;
  opacity: 0;
  position: absolute;
  left: -50%;
  width: 300%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateY(15px);
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
}
button.hover-black:hover > svg {
  fill: black !important;
}
button.coral-hover-black > svg {
  fill: #40c4ff;
}
button.coral-hover-black:hover > svg {
  fill: black !important;
}
button.white-hover-white > svg {
  fill: white;
}
button.white-hover-white:hover > svg {
  fill: white !important;
  transform: scale(1.1);
}
/*# sourceMappingURL=remove-button.component.css.map */
